import styled from 'styled-components';

const maxWidth = 220;
const minWidth = 154;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const SelectedOption = styled.button`
  min-width: ${props => props.minWidth || minWidth}px;
  max-width: ${props => props.maxWidth || maxWidth}px;
  height: 50px;
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-size: 18px;
  text-transform: uppercase;
  background-color: #fff;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const ContainerOptions = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  background-color: #fff;
  min-width: ${props => props.minWidth || minWidth}px;
  max-width: ${props => props.maxWidth || maxWidth}px;
  max-height: ${props => props.maxHeight || 360}px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 5px;
  border-radius: 6px;
  top: calc(100% + 4px);
  left: 0;
  border: 1px solid var(--primary);
  position: absolute !important;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--primary);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f0f0f0;
    border-radius: 3px;
  }
`;

export const Option = styled.div`
  width: 100%;
  padding: 10px 8px;
  text-transform: uppercase;
  color: var(--primary);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 2px;
  cursor: pointer;
  font-weight: ${props => (props.selected ? 'bold' : 'normal')};
  line-height: 1.2;
  flex-shrink: 0;
  & + & {
    border-top: 1px solid var(--primary);
  }
`;
